
import { useTheme } from "@mui/material/styles";
import { Grid2, Link, Typography } from "@mui/material";
import Minibar, {
  MinibarItemWithComponent,
  MinibarItemWithIcon,
} from "./Minibar";
import { Action } from "./Action";
import HeaderBreadcrumbs, { BreadcrumbElement } from "./HeaderBreadcrumbs";
import ActionIconButton from "./ActionIconButton";
import NavigationIcons from "./NavigationIcons";

export interface PageHeaderProps {
  title: string | JSX.Element;
  minibarItems?: (MinibarItemWithIcon | MinibarItemWithComponent)[];
  rightComponent?: JSX.Element[];
  iconAction?: Action;
  breadcrumbLink?: Action;
  buttons?: Action[];
  boldFont?: boolean;
  breadcrumbElements?: BreadcrumbElement[];
}

const PageHeader = ({
  title,
  minibarItems,
  iconAction,
  breadcrumbLink,
  rightComponent,
  buttons,
  boldFont,
  breadcrumbElements,
}: PageHeaderProps): JSX.Element => {
  const theme = useTheme();
  return (
    <>
      <Grid2
        container
        alignItems="center"
        justifyContent="space-between"
        sx={{
          display: "flex",
          flexWrap: "nowrap",
          gap: "1rem",
          height: "65px",
          width: "100%",
          margin: "0px",
          padding: "0 1rem",
          borderBottom: `1px solid ${theme.palette.divider}`,
        }}
      >
        {title &&
          <Grid2 size={{ xs: 8, md: 12 }}>
            <Typography
              sx={{
                fontWeight: boldFont ? 500 : undefined,
                // marginTop: "0.25rem",
                // marginBottom: "0.75rem",
              }}
              variant="h5"
            >
              {title}
            </Typography>
          </Grid2>
        }

        {/* Breadcrumbs in the center */}
        <Grid2
          sx={{
            flexGrow: 1, // This ensures breadcrumbs take available space between title and minibar
            display: "flex",
            justifyContent: "flex-start", // Align breadcrumbs to the left within the center space
            height: "100%",
            alignItems: "center", // Align items vertically centered
          }}
        >
          {breadcrumbLink && (
            <div>
              <Link href={breadcrumbLink.nav}>{breadcrumbLink.label}</Link>
            </div>
          )}
          {breadcrumbElements && (
            <HeaderBreadcrumbs breadcrumbElements={breadcrumbElements} />
          )}
        </Grid2>

        {/* Minibar and right-aligned components */}
        <Grid2
          sx={{
            display: "flex",
            gap: "1rem",
            justifyContent: "flex-end",
            alignItems: "center", // Align items vertically centered
          }}
        >
          {rightComponent?.map((component, index) => (
            <div key={index}>{component}</div>
          ))}
          {minibarItems && (
            <Minibar minibarItems={minibarItems} barLength={0} />
          )}
          {iconAction && <ActionIconButton action={iconAction} />}
          {buttons && <NavigationIcons buttons={buttons} />}
        </Grid2>
      </Grid2>
    </>
  );
};

export default PageHeader;
